import { LatLngTuple } from 'leaflet';
import { decode } from '@here/flexpolyline';

export const decodePolyline = (encoded: string | null): LatLngTuple[] => {
  if (!encoded) return [];

  try {
    return decode(encoded).polyline as LatLngTuple[];
  } catch {
    return [];
  }
};
